package fr.frux.core.maps.di

import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provides
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import fr.frux.core.maps.LocationProvider
import fr.frux.core.maps.SessionCachedLocationProvider
import fr.frux.core.maps.createLocationProvider

/** Module Metro fournissant le [LocationProvider], sur le modele de TokenStorageModule. */
@ContributesTo(AppScope::class)
interface LocationModule {
    companion object {
        @Provides
        @SingleIn(AppScope::class)
        fun provideLocationProvider(): LocationProvider = SessionCachedLocationProvider(createLocationProvider())
    }
}
